module.exports = __webpack_public_path__ + "img/e_2_1_g.e4502f38.png";